import React from "react";
import {
  MdMessage,
  MdNotifications,
  MdSearch,
  MdKeyboardArrowDown,
} from "react-icons/md";
import { Link } from "react-router-dom";
import "./Header.css";

function Header() {
  return (
    <header className="top-header">
      {/* Left */}
      <div className="header-left">

        <div className="search-box">
          <MdSearch className="search-icon" />
          <input type="text" placeholder="Search anything..." />
        </div>
      </div>

      {/* Right */}
      <div className="header-right">
        <div className="icon-box">
          <MdMessage />
          <span className="badge">2</span>
        </div>

        <div className="icon-box">
          <MdNotifications />
          <span className="badge red">5</span>
        </div>

        <div className="profile-box">
          <div className="avatar">DA</div>

          <div className="user-info">
            <h5>David Admin</h5>
            <p>Super Admin</p>
          </div>

          <MdKeyboardArrowDown />
        </div>
      </div>
    </header>
  );
}

export default Header;